<app-spinner [loading]="isCreating"></app-spinner>
<section class="create-cryptotoken-key">
  <form [formGroup]="form" appFormFields (ngSubmit)="onSubmit()" class="create-cryptotoken-key__form">
    <div class="create-cryptotoken-key__inputs">
        <app-form-field [name]="CreateCryptoTokenKeyField.alias"></app-form-field>
        <app-form-field [name]="CreateCryptoTokenKeyField.keySpecification"></app-form-field>
        <div class="create-cryptotoken-key__buttons">
          <button type="submit" mat-button class="button">{{labels.buttons.generate}}</button>
        </div>
    </div>
  </form>
</section>
